import { FC, useCallback } from 'react'
import ImageCloseCircle from 'assets/image/close-circle.png'
import ImagePolygon from 'assets/image/polygon.png'
import ImageHome from 'assets/image/home.png'
import ImageServicePro from 'assets/image/service-pro.png'
import ImageServiceVehicle from 'assets/image/service-vehicle.png'
import ImageRoutes from 'assets/image/routes.png'
import { RouteLayer } from 'interface/route'
import styles from './index.module.scss'

interface Option {
  key: RouteLayer
  title: string
  description: string
  icon: string
}

type RouteLayersPopoverContentProps = {
  routeLayers: RouteLayer[]
  onClickOption: (key: RouteLayer) => void
  onClickClose: () => void
}

export const RouteLayersPopoverContent: FC<RouteLayersPopoverContentProps> = ({
  routeLayers,
  onClickOption,
  onClickClose,
}) => {
  const options: Option[] = [
    {
      key: 'homes',
      title: 'Homes',
      description: 'View the homes that are on the different routes',
      icon: ImageHome
    },
    {
      key: 'routes',
      title: 'Routes',
      description: 'View the actual driving route created by ARO',
      icon: ImageRoutes
    },
    {
      key: 'service-vehicles',
      title: 'Service Vehicles',
      description: 'Live location view of the Service Vehicle',
      icon: ImageServiceVehicle
    },
    {
      key: 'service-pro',
      title: 'Service Pro',
      description: 'Overlay the Service Pro avatar on the route polygon',
      icon: ImageServicePro
    },
    {
      key: 'route-polygon',
      title: 'Route Polygon',
      description: 'View the outside boundary of a route',
      icon: ImagePolygon
    },
  ]

  const isOptionSelected = useCallback((option: Option) => {
    return routeLayers.includes(option.key)
  }, [routeLayers])

  return (
    <div className="w-[240px]">
      <div className="h-[40px] bg-[#F5F5F5] flex items-center justify-center relative">
        <div className="text-sm font-bold">Route Layers</div>
        <div className="absolute right-2 cursor-pointer" onClick={onClickClose}>
          <img src={ImageCloseCircle} alt="ImageCloseCircle" />
        </div>
      </div>
      <div className="p-2 pt-0">
        {options.map((option) => (
          <div
            key={option.key}
            className={`mt-2 border rounded p-2 flex cursor-pointer ${isOptionSelected(option) ? 'bg-[#007AFF] border-[#007AFF]' : 'border-[#F3F4F6]'}`}
            onClick={() => onClickOption(option.key)}
          >
            <div className={`w-[24px] mr-2 ${isOptionSelected(option) ? styles.svg_path_stroke_white : styles.svg_path_stroke_black}`}>
              <img src={option.icon} alt="ImageCloseCircle" />
            </div>
            <div>
              <div className={`text-xs font-bold ${isOptionSelected(option) ? 'text-white' : ''}`}>
                {option.title}
              </div>
              <div className={`text-xs ${isOptionSelected(option) ? 'text-white' : ''}`}>
                {option.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
